import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import {
  Row,
  Col,
  Table,
  // Well,
  InputGroup,
  FormGroup,
  FormControl,
  Button,
  Glyphicon
} from 'react-bootstrap'

import './style.css'

import {
  getPublicationsWithFilters,
  getPublicationMetadata,
  getPublicationFieldsData,
  changePublicationsPage,
  changePublicationsFilter,
  togglePublicationManagementMode,
  clearAllPublicationApprovalFilters,
} from './reducers/managePublications'

import { getUsers } from '../login/reducers/manageLogin'

import AuthenticationComponent from '../../AuthenticationComponent'

import Publication from './components/Publication'
import PublicationFilterContainer from './components/PublicationFilterContainer'

import PaginationButtons from '../../reuseable-components/PaginationButtons'
import ManagementModeToggle from './components/ManagementModeToggle'


class PublicationsContainer extends Component {

  state = {
    lastPaginationPage: this.props.currentPublicationsPage,
  }

  componentDidMount() {
    this.props.getPublicationMetadata()
    let pageNumber = this.props.currentPublicationsPage
    if (this.props.publications.length === 0) {
      pageNumber = 1
    }

    this.props.getPublicationsWithFilters(pageNumber, this.props)

    if (this.props.currentPublicationsPage < 5) {
      this.setState({lastPaginationPage: 5})
    }

    if (this.props.currentPublicationsPage % 5 > 0) {
      let remainder = this.props.currentPublicationsPage % 5
      let lastPaginationPage = this.props.currentPublicationsPage - remainder + 5
      this.setState({ lastPaginationPage })
    }

    if (this.props.users.length === 0) {
      this.props.getUsers()
    }

    this.props.getPublicationFieldsData()
  }

  handlePaginationButtonChange = (currentPage, lastPage) => {
    if (currentPage === this.state.lastPaginationPage + 1) {
      this.setState({lastPaginationPage: this.state.lastPaginationPage + 5})
    }
    if (currentPage + 5 === this.state.lastPaginationPage) {
      this.setState({lastPaginationPage: this.state.lastPaginationPage - 5})
    }
    if (currentPage === 1) {
      this.setState({lastPaginationPage: 5})
    }
    if (currentPage === lastPage) {
      let lastPaginationPage = lastPage
      if (lastPage % 5 > 0) {
        let remainder = lastPage % 5
        lastPaginationPage = lastPage - remainder + 5
      }
      this.setState({ lastPaginationPage })
    }
  }


  handlePaginationButtonClick = (i, currentPage, lastPage) => {
    this.props.changePublicationsPage(i)
    this.props.getPublicationsWithFilters(i, this.props)
    this.handlePaginationButtonChange(currentPage, lastPage)
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }

  handleEnterPress = (e) => {
    if (e.key === 'Enter') {
      this.props.changePublicationsPage(1)
      this.props.getPublicationsWithFilters(1, this.props)
    }
  }

  handleSetManagementMode = (e) => {
    this.setState({managementMode: !this.state.managementMode})
  }


  render() {

    const {
      publications,
      fetchingPublications,
      history,
      filteredPublicationCount,
      publicationsPerPage,
      currentPublicationsPage,
      publicationsSearchTerm
    } = this.props

    // THIS WILL SHOW THE NUMBER OF PAGES FOR THE PAGINATION BUTTONS
    let numberOfPages
    if (publications && publications.length > 0) {
      numberOfPages = Math.ceil(filteredPublicationCount / publicationsPerPage)
    }

    return (
      <div id='PublicationsContainer'>
        <AuthenticationComponent />

          <Row>
            <Col xs={12} sm={12} md={3} lg={3}>
              <PublicationFilterContainer history={this.props.history} />
            </Col>
            <Col xs={12} sm={12} md={9} lg={9}>
              {fetchingPublications ?
                <center>
                  <div id="not-found">
                    <img alt="loader" src={require("../../static/images/spinner.gif")} />
                  </div>
                </center>
                :
                <Fragment>
                  <Row>
                    <Col md={6}>
                      <div style={{ marginTop: "18px" }}>
                        <FormGroup>
                          <InputGroup>
                            <FormControl
                              id='publicationsSearchTermInput'
                              type="search"
                              value={publicationsSearchTerm}
                              placeholder="Search by any field"
                              onChange={(e) => this.props.changePublicationsFilter('publicationsSearchTerm', e.target.value)}
                              onKeyDown={this.handleEnterPress}
                            />
                            <InputGroup.Button>
                              <Button
                                bsStyle={publicationsSearchTerm ? "info" : "default"}
                                onClick={() => {
                                  this.props.changePublicationsPage(1)
                                  this.props.getPublicationsWithFilters(1, this.props)
                                }}
                              >
                                <Glyphicon glyph="search" />
                              </Button>
                            </InputGroup.Button>
                          </InputGroup>
                        </FormGroup>
                      </div>
                    </Col>
                    {numberOfPages > 1 ?
                      <Col md={6}>
                        <center style={{fontSize:"8pt"}}>
                          <PaginationButtons
                            style={{ display: "inline-block" }}
                            numberOfPages={numberOfPages}
                            currentPage={currentPublicationsPage}
                            lastPage={this.state.lastPaginationPage}
                            buttonsPerPage={5}
                            onClick={this.handlePaginationButtonClick}
                          />
                        </center>
                      </Col>
                      :
                      null
                    }
                  </Row>
                  {this.props.currentUser.is_publication_manager ?
                    <Row>
                      <Col md={12} style={{textAlign: "center"}}>
                        <ManagementModeToggle
                          publicationManagementMode={this.props.publicationManagementMode}
                          togglePublicationManagementMode={this.props.togglePublicationManagementMode}
                          clearAllPublicationApprovalFilters={this.props.clearAllPublicationApprovalFilters}
                        />
                      </Col>
                    </Row>
                    :
                    null
                  }
                  {/* <Well> */}
                    {publications && publications.length ?
                      <Fragment>
                        <Table responsive className="publications-table">
                          <thead>
                            <tr>
                              <td>
                                Citation
                              </td>
                              <td>
                                Genesis Authors
                              </td>
                              <td>
                                Year
                              </td>
                              <td>
                                Journal/Conference
                              </td>
                              {this.props.publicationManagementMode ?
                                <td>
                                  Show URL on Website?
                                </td>
                                :
                                null
                              }
                            </tr>
                          </thead>
                          <tbody>
                            {publications.map(publication => {
                              return (
                                <Publication
                                  key={publication.id}
                                  publication={publication}
                                  history={history}
                                  publicationManagementMode={this.props.publicationManagementMode}
                                  toggleModal={this.toggleModal}
                                />
                                )
                              })
                            }
                          </tbody>
                        </Table>
                      </Fragment>
                      :
                      <center>
                        <h4>
                          No publications to display
                        </h4>
                      </center>
                    }
                  {/* </Well> */}
                  <Row>
                    {numberOfPages > 1 ?
                      <Col>
                        <center style={{fontSize:"8pt"}}>
                          <PaginationButtons
                            style={{ display: "inline-block" }}
                            numberOfPages={numberOfPages}
                            currentPage={currentPublicationsPage}
                            lastPage={this.state.lastPaginationPage}
                            buttonsPerPage={5}
                            onClick={this.handlePaginationButtonClick}
                          />
                        </center>
                      </Col>
                      :
                      null
                    }
                  </Row>
                </Fragment>
              }
            </Col>
          </Row>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    // REDUX METADATA //
    fetchingPublications: state.managePublications.fetchingPublications,
    filteredPublicationCount: state.managePublications.filteredPublicationCount,
    publicationsPerPage: state.managePublications.publicationsPerPage,
    currentPublicationsPage: state.managePublications.currentPublicationsPage,
    publicationManagementMode: state.managePublications.publicationManagementMode,
    // DATA //
    users: state.manageLogin.users,
    currentUser: state.manageLogin.user,
    publications: state.managePublications.publications,
    therapeuticAreas: state.managePublications.therapeuticAreas,
    studyDesigns: state.managePublications.studyDesigns,
    dataSources: state.managePublications.dataSources,
    dataSourceTypes: state.managePublications.dataSourceTypes,
    methodAnalysisTypes: state.managePublications.methodAnalysisTypes,
    // FILTERS & SORTING //
    publicationsSearchTerm: state.managePublications.publicationsSearchTerm,
    publicationsSortType: state.managePublications.publicationsSortType,
    publicationsApprovalStatusSortType: state.managePublications.publicationsApprovalStatusSortType,
    publicationsApprovalStatusFilter: state.managePublications.publicationsApprovalStatusFilter,
    publicationsAuthorFilter: state.managePublications.publicationsAuthorFilter,
    publicationsYearFilter: state.managePublications.publicationsYearFilter,
    publicationsClientFilter: state.managePublications.publicationsClientFilter,
    publicationsProductFilter: state.managePublications.publicationsProductFilter,
    publicationsIndicationFilter: state.managePublications.publicationsIndicationFilter,
    publicationsTherapeuticAreasFilter: state.managePublications.publicationsTherapeuticAreasFilter,
    publicationsStudyDesignsFilter: state.managePublications.publicationsStudyDesignsFilter,
    publicationsPublicationTypeFilter: state.managePublications.publicationsPublicationTypeFilter,
    publicationsMethodAnalysisTypesFilter: state.managePublications.publicationsMethodAnalysisTypesFilter,
    publicationsDataSourcesFilter: state.managePublications.publicationsDataSourcesFilter,
    publicationsDataSourceTypesFilter: state.managePublications.publicationsDataSourceTypesFilter,
    publicationsDoneWithGenesis: state.managePublications.publicationsDoneWithGenesis,
    publicationsRegulatoryRelated: state.managePublications.publicationsRegulatoryRelated,
  }
}

const mapDispatchToProps = {
  getPublicationsWithFilters,
  getPublicationMetadata,
  getPublicationFieldsData,
  togglePublicationManagementMode,
  clearAllPublicationApprovalFilters,
  changePublicationsPage,
  changePublicationsFilter,
  getUsers
}

export default connect(mapStateToProps, mapDispatchToProps)(PublicationsContainer)



// WEBPACK FOOTER //
// ./src/routes/publications/PublicationsContainer.js